<template>
    <b-container fluid>        
      <b-row align-h="center">

        <!-- <b-col cols="12" class="bg-title">
          <h5 style="cursor:pointer; color:white;" class="mt-1 mb-2 d-none d-lg-block">
            <font> Ley de Ingresos</font>
          </h5>
          <h5 style="cursor:pointer; color:white;" class="mt-1 mb-2 d-block d-lg-none">
            <b-icon @click="isShowTree=!isShowTree; " icon="list" shift-v="-2" font-scale="1.3"/>
              <font> Ley de Ingresos</font>
          </h5>
        </b-col>  -->
        <!-- <Transition>
        <b-col cols="12" sm="10" md="8" lg="4" xl="3" v-if="false">
          <b-row no-gutters >
            
            <b-col cols="12" sm="12" md="12" lg="11" xl="10"   class="sidebar-siprem">
              <b-row>
                <b-col>
                  <TreeCollapse/>
                </b-col>
              </b-row>
            </b-col>
            
          </b-row>
        </b-col>
      </Transition> -->
        
        <b-col cols="12" sm="12" md="12" lg="11" xl="11">
          <!-- <div v-if="isShowTreeBackdrop" class="sidebar-overlay"></div> -->
          
          <b-row >
            <b-col cols="12" sm="12" md="10" lg="12"  class="mt-5 ">
                <LiqForm :getLiquidacion="getLiquidacion"/>
            </b-col>
            <b-col cols="12" sm="12" md="10" lg="12" class=" mb-2">
              <LiqTable  :datosPago="datosPago" :parcialidades="parcialidades" :totalLiquidacion="totalLiquidacion" :getLiquidacion="getLiquidacion" :getLiquidacionSin="getLiquidacionSinAgregar" :resumen="resumenLiquidacion" :tipoVista="tipoVistaLiq"/> 
            </b-col>
            <b-col cols="12" sm="12" md="10" lg="12"  >
              <OptionsLiqTable id="liqTableOptions" :getLiquidacion="getLiquidacion"/>
            </b-col>
            <b-col cols="12" v-if="isCalculando">
                <b-overlay :show="isCalculando" rounded="lg">
                  <div style="height:600px;"></div>
               </b-overlay>
            </b-col>
          </b-row>            
        </b-col>
      </b-row>

      <!--  MODALS -->
    <b-modal v-model="isShowModalCobro" size="lg" hide-footer header-bg-variant="dark" header-text-variant="light">
      <template #modal-header="{ close }">
        <h5><b-icon icon="table"/> Emisión de documentos</h5>
        <b-button size="sm" @click="close()"><b-icon icon="x"/></b-button>
      </template>
    
      <b-row>
        <b-col>
          <docs-tramite :isPublico="false" :tokenUser="token" />
        </b-col>
      </b-row>
   
    </b-modal>
    </b-container>
</template>

<script>
import axios from 'axios'
import { server, checkAuth, getPostConfig, handledError } from '@/axios-tools'
import { navTo, downloadB64Pdf, generarTxtFileUtf8 } from '@/vue-tools'
import LiqForm from '@/components/cobro/LiqForm.vue'
import LiqTable from '@/components/cobro/LiqTable.vue'
import OptionsLiqTable from '@/components/cobro/OptionsLiqTable.vue'
import { mapState} from 'vuex'
import DocsTramite from './DocsTramite.vue'

export default {
  computed:{
   ...mapState({
      parcialidades: state => state.cobro.parcialidades,
      totalLiquidacion: state => state.cobro.totalLiquidacion,
      resumenLiquidacion: state => state.cobro.resumenLiquidacion,
      datosPago: state => state.cobro.datosPago,
      subsidiosAplicados: state => state.cobro.subsidiosAplicados,
      formModel: state => state.cobro.formModel,
      liqForms: state => state.cobro.formsModels,
      isShowModalCobro1: state => state.cobro.isShowModalCobro,
      pdfsGenerated: state => state.cobro.pdfsGenerated,
      token: state => state.login.token,
      isCalculando: state => state.cobro.isCalculando,
      isGenerando: state => state.cobro.isGenerando,
      isShowSideCobro: state => state.cobro.isShowSideCobro,
    }),
    isShowModalCobro: {
        get () { return this.isShowModalCobro1},
        set (value) { this.$store.commit("updateIsShowModalCobro", value); }
    },
    tipoVistaLiq:function(){
      return this.$route.params.municipio=='aguahuixquilucan'
      ?'acumulada':'default';
    }
  },
  data(){
    return{
    }
  },
  mounted(){
    window.scrollTo(0, 0);
  },
  components: {
    LiqForm,
    LiqTable,
    OptionsLiqTable,
    DocsTramite,
  },
  methods:{
    getLiquidacion(isOrden, nueva, idxUltParcialidad){
        this.cleanResults();
        if(!this.isCalculando && !this.isGenerando && checkAuth(this.$router, this.$store)){
            this.$store.commit("updateIsCalculando", true);
            this.$store.commit("updateidxUltParcialidad", idxUltParcialidad); //Siempre para una nueva peticion
            if(nueva){
                this.$store.commit("cleanFormsModels");
            }
            this.$store.commit("addToFormsModels", JSON.parse(JSON.stringify(this.formModel))); 
            axios(
                isOrden?
                getPostConfig(server.liquidacionorden, null, this.token, {serieFolio:this.formModel.inTxt4.model}):
                getPostConfig(server.liquidacion, this.liqForms, this.token)
                
            )
            .then(res => {
                this.$store.commit("updateDatosPago", res.data[0]);
                this.$store.commit("updateParcialidades", res.data[1]);
                this.$store.commit("updateTotalLiquidacion", res.data[2]);
                this.$store.commit("updateResumenLiquidacion", res.data[3]);
                this.$store.commit("updateSubsidiosAplicados", res.data[4]);
                
                this.$store.commit("updateIsCalculando", false);
                this.$store.commit("updateIsLiqFormCollapse", true);
                navTo('liqTableOptions');
            }).catch(err => {
                this.$store.commit("updateIsCalculando", false);
                handledError(err, server.liquidacion, this.$router, this.$store);
            });
        }
    },
    getLiquidacionSinAgregar(){
        this.cleanResults();
        if(!this.isCalculando && !this.isGenerando && checkAuth(this.$router, this.$store)){
            this.$store.commit("updateIsCalculando", true);
            this.$store.commit("updateidxUltParcialidad", 99999); //Siempre para una nueva peticion
            axios(
                getPostConfig(server.liquidacion, this.liqForms, this.token)
                
            )
            .then(res => {
                this.$store.commit("updateDatosPago", res.data[0]);
                this.$store.commit("updateParcialidades", res.data[1]);
                this.$store.commit("updateTotalLiquidacion", res.data[2]);
                this.$store.commit("updateResumenLiquidacion", res.data[3]);
                this.$store.commit("updateSubsidiosAplicados", res.data[4]);
                
                this.$store.commit("updateIsCalculando", false);
                this.$store.commit("updateIsLiqFormCollapse", true);
                navTo('liqTableOptions');
            }).catch(err => {
                this.$store.commit("updateIsCalculando", false);
                handledError(err, server.liquidacion, this.$router, this.$store);
            });
        }
    },
    cleanResults (){
        if(!this.isCalculando & !this.isGenerando ){
            this.$store.commit("clearResultsCobro");
        }
    },
    downloadPdf(pdfGenerated, nombre){
        downloadB64Pdf(pdfGenerated, nombre);
    },
    downloadXml(xml){
       generarTxtFileUtf8("cfdi", xml, "xml")
    }
  }
}
</script>
<style>
  
</style>